import React from "react";

// Round badge logo (hunter-green ring, gold ornamental border) — used as a
// splash-style mark above the wordmark on customer-facing login/register screens.
export function RoundLogo({ className = "h-16 w-16", testId = "round-logo" }) {
  return (
    <img
      src="/icons/customer-icon-512.png"
      alt="The Virsa Tiffin"
      className={`${className} select-none rounded-full shadow-lg`}
      data-testid={testId}
      draggable={false}
    />
  );
}
